import React from 'react'
import { StickyElement } from '../../components/component-items/helpers'
import { MenuOptions } from '../../components/component-items/menu-option'
import { Col, Row } from 'react-bootstrap'

// Components
import { MenuOption } from '../../components/component-items/menu-option'
import { CompanySettings } from './settings'
import { NotificationList } from '../../components/notifications'
import { PermissionGate } from '../../components/rbac'
import { globalState } from '../../store'
import { ApiKeysModal } from './settings/api-keys-modal'
import { AddressModal } from './settings/address-modal'
import { UpdatePricesModal } from './settings/update-prices-modal'

// Cards
import { StatusBar } from './status-bar'

// Fontawesome
import { faKey, faAddressBook, faHandHoldingUsd } from '@fortawesome/pro-duotone-svg-icons'

export const Company = () => {
  const {
    state: { companyId, userIsWarehouse },
  } = globalState()
  const [apiKeysModal, setApiKeysModal] = React.useState(false)
  const [addressModal, setAddressModal] = React.useState(false)
  const [updatePricesModal, setUpdatePricesModal] = React.useState(false)

  return (
    <>
      <StatusBar />
      <Row>
        <Col xl={2}>
          <StickyElement>
            <MenuOptions>
              <ul>
                <PermissionGate segment="settings" minLevel="admin">
                  <MenuOption onClick={() => setApiKeysModal(true)} icon={faKey} title={'API Keys'} />
                  <ApiKeysModal open={apiKeysModal} setOpen={setApiKeysModal} />
                </PermissionGate>
                <MenuOption onClick={() => setAddressModal(true)} icon={faAddressBook} title={'Company Address'} />
                <AddressModal open={addressModal} setOpen={setAddressModal} />
                <MenuOption
                  onClick={() => setUpdatePricesModal(true)}
                  icon={faHandHoldingUsd}
                  title={'Update Prices'}
                />
                <UpdatePricesModal open={updatePricesModal} setOpen={setUpdatePricesModal} />
              </ul>
            </MenuOptions>
          </StickyElement>
        </Col>
        <Col xl={7}>
          <Row>
            <Col xs={12}>
              {userIsWarehouse ? <CompanySettings context="warehouse" /> : <CompanySettings context="company" />}
            </Col>
          </Row>
        </Col>
        <Col xl={3}>
          <StickyElement>
            <NotificationList id={companyId} type="company" />
          </StickyElement>
        </Col>
      </Row>
    </>
  )
}
